import React from 'react'
import Modal from 'react-bootstrap/Modal';
import BaseModal from './base-modal';

class ModalCustom extends BaseModal {
  constructor(props) {
    super(props);
  }

  render() {
    const { message } = this.props
    return (
      <Modal show={this.state.show} onHide={this.closeModal} size="lg">
        <Modal.Header closeButton>
          <Modal.Title className="text-primary">{message}</Modal.Title>
        </Modal.Header>
      </Modal>
    )
  }
}

export default ModalCustom